import { render, staticRenderFns } from "./SupersessionManager.vue?vue&type=template&id=615c9285&scoped=true"
import script from "./SupersessionManager.vue?vue&type=script&lang=js"
export * from "./SupersessionManager.vue?vue&type=script&lang=js"
import style0 from "./SupersessionManager.vue?vue&type=style&index=0&id=615c9285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c9285",
  null
  
)

export default component.exports